var map = {
  "./avatars/abbey.svg": "25093",
  "./avatars/ace.svg": "55",
  "./avatars/amy.svg": "38217",
  "./avatars/cognibot_simple.svg": "50366",
  "./avatars/generic-profile.svg": "44357",
  "./avatars/haley.svg": "39711",
  "./avatars/jamie.svg": "22006",
  "./avatars/jennifer.svg": "43235",
  "./avatars/nadia.svg": "33209",
  "./avatars/tyler.svg": "53774",
  "./complex-icons/2fa.svg": "1966",
  "./complex-icons/accessibility.svg": "96389",
  "./complex-icons/account-organization.svg": "33724",
  "./complex-icons/actions.svg": "62118",
  "./complex-icons/activity-log.svg": "55271",
  "./complex-icons/address-autocomplete.svg": "90086",
  "./complex-icons/affordable.svg": "20587",
  "./complex-icons/agreement.svg": "48841",
  "./complex-icons/ai-sparkle.svg": "50196",
  "./complex-icons/analytics-tracking.svg": "81767",
  "./complex-icons/api.svg": "2213",
  "./complex-icons/appreciate.svg": "84679",
  "./complex-icons/approvals.svg": "91909",
  "./complex-icons/authenticated-forms.svg": "37344",
  "./complex-icons/automated-receipts.svg": "30869",
  "./complex-icons/build-blocks.svg": "10692",
  "./complex-icons/build.svg": "17317",
  "./complex-icons/bulk-file-downloads.svg": "3004",
  "./complex-icons/calculations.svg": "65931",
  "./complex-icons/card-on-file.svg": "24144",
  "./complex-icons/celebrate.svg": "63792",
  "./complex-icons/client-portal.svg": "97313",
  "./complex-icons/cognibot.svg": "75362",
  "./complex-icons/conditional-logic.svg": "8838",
  "./complex-icons/create-entries.svg": "31804",
  "./complex-icons/custom-orders.svg": "42166",
  "./complex-icons/custom-permissions.svg": "60487",
  "./complex-icons/data-collection.svg": "83634",
  "./complex-icons/data-encryption.svg": "95959",
  "./complex-icons/data-management.svg": "14513",
  "./complex-icons/discount-codes.svg": "46529",
  "./complex-icons/document-generation.svg": "39631",
  "./complex-icons/document-merging.svg": "11862",
  "./complex-icons/due-dates.svg": "65147",
  "./complex-icons/electronic-signatures.svg": "58311",
  "./complex-icons/email-notifications.svg": "204",
  "./complex-icons/entry-management.svg": "629",
  "./complex-icons/entry-sharing.svg": "41760",
  "./complex-icons/event-registrations.svg": "13334",
  "./complex-icons/export-data.svg": "90180",
  "./complex-icons/faq.svg": "49645",
  "./complex-icons/file-uploads.svg": "38612",
  "./complex-icons/folders.svg": "78336",
  "./complex-icons/form.svg": "84531",
  "./complex-icons/free.svg": "91355",
  "./complex-icons/gdpr.svg": "52468",
  "./complex-icons/getting-started.svg": "24177",
  "./complex-icons/google-analytics-icon.svg": "91793",
  "./complex-icons/government.svg": "8298",
  "./complex-icons/guest-access.svg": "33584",
  "./complex-icons/hipaa-compliance.svg": "29048",
  "./complex-icons/import-form-entries.svg": "48890",
  "./complex-icons/import-form.svg": "21203",
  "./complex-icons/import-g.svg": "99536",
  "./complex-icons/import-j.svg": "459",
  "./complex-icons/import-spreadsheet.svg": "23303",
  "./complex-icons/innovate.svg": "3639",
  "./complex-icons/integrations.svg": "42078",
  "./complex-icons/integrity.svg": "1826",
  "./complex-icons/limit-exceeded.svg": "80782",
  "./complex-icons/logic-automation.svg": "66123",
  "./complex-icons/lookup-field.svg": "79670",
  "./complex-icons/manage-payments.svg": "49608",
  "./complex-icons/multi-page-forms.svg": "24728",
  "./complex-icons/nil.svg": "45794",
  "./complex-icons/online-store.svg": "45830",
  "./complex-icons/parallel-tasks.svg": "10957",
  "./complex-icons/payment.svg": "28379",
  "./complex-icons/percent.svg": "19060",
  "./complex-icons/performance.svg": "48851",
  "./complex-icons/person-field.svg": "45793",
  "./complex-icons/person-form.svg": "22187",
  "./complex-icons/person-submissions.svg": "65896",
  "./complex-icons/plans-billing.svg": "79131",
  "./complex-icons/popular.svg": "8072",
  "./complex-icons/privacy-shield.svg": "12099",
  "./complex-icons/publish.svg": "63750",
  "./complex-icons/quantity-limits.svg": "56157",
  "./complex-icons/quote.svg": "92977",
  "./complex-icons/rapid-development.svg": "54599",
  "./complex-icons/rating-scales.svg": "29238",
  "./complex-icons/recurring-payments.svg": "38656",
  "./complex-icons/referral.svg": "13516",
  "./complex-icons/repeating-sections-tables.svg": "24963",
  "./complex-icons/responsive-forms.svg": "17741",
  "./complex-icons/sales.svg": "30541",
  "./complex-icons/save-resume.svg": "89678",
  "./complex-icons/saved-entry-views.svg": "1044",
  "./complex-icons/scalable.svg": "28962",
  "./complex-icons/school.svg": "38281",
  "./complex-icons/security.svg": "61411",
  "./complex-icons/service-bookings.svg": "74059",
  "./complex-icons/simplify.svg": "28998",
  "./complex-icons/spam-prevention.svg": "34821",
  "./complex-icons/speedometer-advanced.svg": "68207",
  "./complex-icons/speedometer-intermediate.svg": "14896",
  "./complex-icons/speedometer.svg": "54752",
  "./complex-icons/sso.svg": "13998",
  "./complex-icons/stopwatch.svg": "89998",
  "./complex-icons/style-customization.svg": "33308",
  "./complex-icons/support.svg": "2874",
  "./complex-icons/table.svg": "17633",
  "./complex-icons/tablet-payment.svg": "54574",
  "./complex-icons/tasks.svg": "80935",
  "./complex-icons/tenacious.svg": "75206",
  "./complex-icons/theme.svg": "47152",
  "./complex-icons/trophy.svg": "90823",
  "./complex-icons/unlimited-forms-fields.svg": "55260",
  "./complex-icons/v2.svg": "27333",
  "./complex-icons/visibility.svg": "55289",
  "./complex-icons/wallet.svg": "84336",
  "./complex-icons/webhooks.svg": "11891",
  "./complex-icons/webinars.svg": "32250",
  "./complex-icons/website-embedding.svg": "78400",
  "./complex-icons/work.svg": "77928",
  "./complex-icons/workflow-links.svg": "9423",
  "./complex-icons/workflow.svg": "61464",
  "./complex-icons/youtube.svg": "71124",
  "./concentric/ai-form-generation.svg": "8092",
  "./concentric/blog-mobile.svg": "13095",
  "./concentric/blog-top.svg": "93518",
  "./concentric/blog.svg": "36704",
  "./concentric/ceres.svg": "58760",
  "./concentric/faq.svg": "78250",
  "./concentric/faq2.svg": "20066",
  "./concentric/footer.svg": "37843",
  "./concentric/gear-top.svg": "65337",
  "./concentric/gear.svg": "95679",
  "./concentric/guides.svg": "80401",
  "./concentric/home.svg": "55975",
  "./concentric/how-to-guides.svg": "95844",
  "./concentric/idea.svg": "11491",
  "./concentric/industries.svg": "6902",
  "./concentric/integration-main.svg": "5740",
  "./concentric/integration.svg": "80556",
  "./concentric/law.svg": "52802",
  "./concentric/light.svg": "17414",
  "./concentric/logo-top.svg": "96181",
  "./concentric/logo.svg": "66419",
  "./concentric/newsies.svg": "60416",
  "./concentric/online-payment.svg": "55352",
  "./concentric/powerful.svg": "51760",
  "./concentric/pricing.svg": "59476",
  "./concentric/simple-small.svg": "82924",
  "./concentric/simple.svg": "74350",
  "./concentric/spruce.svg": "65582",
  "./concentric/vinyl.svg": "57926",
  "./concentric/workflow-automation.svg": "61225",
  "./icons/action.svg": "68640",
  "./icons/address.svg": "31608",
  "./icons/all-forms-legacy.svg": "10257",
  "./icons/all-forms.svg": "23881",
  "./icons/api.svg": "71360",
  "./icons/approvals.svg": "39960",
  "./icons/archive-open.svg": "87475",
  "./icons/archive.svg": "26370",
  "./icons/arrow-left.svg": "39055",
  "./icons/arrow-right.svg": "55994",
  "./icons/attachments.svg": "67318",
  "./icons/audit-log.svg": "90184",
  "./icons/automation.svg": "12637",
  "./icons/ban.svg": "82401",
  "./icons/bank.svg": "84728",
  "./icons/bold.svg": "46509",
  "./icons/bug-fix.svg": "30184",
  "./icons/build.svg": "97264",
  "./icons/bulk-actions.svg": "4616",
  "./icons/calculations.svg": "18808",
  "./icons/center.svg": "19911",
  "./icons/check-circle.svg": "77501",
  "./icons/check.svg": "53684",
  "./icons/chevron-down.svg": "90680",
  "./icons/chevron-left.svg": "6765",
  "./icons/chevron-right.svg": "97544",
  "./icons/chevron-up.svg": "29309",
  "./icons/choice.svg": "7049",
  "./icons/circle.svg": "65130",
  "./icons/clear-fields.svg": "50587",
  "./icons/cog.svg": "16471",
  "./icons/cognibot.svg": "61337",
  "./icons/collapse-menu.svg": "31945",
  "./icons/columns.svg": "66607",
  "./icons/contact-person.svg": "57948",
  "./icons/continue-workflow.svg": "62849",
  "./icons/copy.svg": "77355",
  "./icons/create-document.svg": "98366",
  "./icons/create-entries.svg": "58619",
  "./icons/credit-card.svg": "89894",
  "./icons/currency.svg": "61185",
  "./icons/cut.svg": "20992",
  "./icons/data.svg": "84042",
  "./icons/date.svg": "79910",
  "./icons/delta-decrease.svg": "52979",
  "./icons/delta-increase.svg": "83971",
  "./icons/document-signing.svg": "1697",
  "./icons/double-chevron-left.svg": "37987",
  "./icons/double-chevron-right.svg": "84678",
  "./icons/download.svg": "44790",
  "./icons/drag-handle-dot.svg": "99225",
  "./icons/drag-handle.svg": "81075",
  "./icons/edit-profile.svg": "74218",
  "./icons/edit-square.svg": "58924",
  "./icons/edit.svg": "21198",
  "./icons/ellipsis.svg": "27193",
  "./icons/email.svg": "89304",
  "./icons/entries.svg": "2176",
  "./icons/error.svg": "53138",
  "./icons/ex-outline.svg": "96592",
  "./icons/ex.svg": "17239",
  "./icons/external-link.svg": "1314",
  "./icons/eye.svg": "19285",
  "./icons/facebook.svg": "92182",
  "./icons/field-above.svg": "14328",
  "./icons/field-below.svg": "23940",
  "./icons/field-left.svg": "89520",
  "./icons/field-right.svg": "41979",
  "./icons/filter.svg": "88300",
  "./icons/flask.svg": "64119",
  "./icons/floating.svg": "59000",
  "./icons/folder.svg": "8726",
  "./icons/form-view.svg": "67836",
  "./icons/form.svg": "51280",
  "./icons/generated-documents.svg": "83850",
  "./icons/github.svg": "13817",
  "./icons/give-access.svg": "35546",
  "./icons/grid.svg": "56398",
  "./icons/guest-person.svg": "56596",
  "./icons/hamburger.svg": "16067",
  "./icons/home.svg": "97745",
  "./icons/hr.svg": "62976",
  "./icons/id.svg": "15847",
  "./icons/identify-submitter.svg": "4004",
  "./icons/image.svg": "3073",
  "./icons/import-form.svg": "85726",
  "./icons/indent.svg": "89968",
  "./icons/infinity.svg": "2466",
  "./icons/info.svg": "35526",
  "./icons/instagram.svg": "65316",
  "./icons/internal.svg": "77235",
  "./icons/italic.svg": "74174",
  "./icons/justify-field.svg": "36125",
  "./icons/justify.svg": "71140",
  "./icons/left.svg": "60995",
  "./icons/light-bulb.svg": "98222",
  "./icons/limited-availability.svg": "18640",
  "./icons/link.svg": "93342",
  "./icons/linkedin.svg": "42824",
  "./icons/loading.svg": "76804",
  "./icons/lock.svg": "429",
  "./icons/login.svg": "68273",
  "./icons/logout.svg": "39556",
  "./icons/lookup.svg": "25532",
  "./icons/minus-square.svg": "63242",
  "./icons/mobile-phone.svg": "8885",
  "./icons/mouse-click.svg": "10770",
  "./icons/multiple-emails.svg": "9882",
  "./icons/name.svg": "76681",
  "./icons/no-eye.svg": "85937",
  "./icons/number.svg": "54011",
  "./icons/ol.svg": "3041",
  "./icons/open-folder.svg": "78967",
  "./icons/organization.svg": "69621",
  "./icons/outdent.svg": "49929",
  "./icons/page-break.svg": "46619",
  "./icons/paste.svg": "74727",
  "./icons/pdf.svg": "25690",
  "./icons/pending.svg": "30491",
  "./icons/person-form-new.svg": "72485",
  "./icons/person-form.svg": "52194",
  "./icons/person.svg": "3495",
  "./icons/phone.svg": "7464",
  "./icons/pin.svg": "4579",
  "./icons/plus-square.svg": "29820",
  "./icons/plus.svg": "65790",
  "./icons/preview.svg": "91804",
  "./icons/price.svg": "11005",
  "./icons/print.svg": "13171",
  "./icons/public-link-disabled.svg": "33041",
  "./icons/public-link.svg": "71308",
  "./icons/public.svg": "15263",
  "./icons/rating-scale.svg": "53096",
  "./icons/read-unread.svg": "84220",
  "./icons/recent.svg": "44393",
  "./icons/refund.svg": "97568",
  "./icons/register.svg": "41319",
  "./icons/repeating-section.svg": "86487",
  "./icons/reset.svg": "86811",
  "./icons/resize.svg": "57242",
  "./icons/retrying.svg": "62236",
  "./icons/right.svg": "17702",
  "./icons/role.svg": "51254",
  "./icons/save-resume.svg": "98495",
  "./icons/save.svg": "78703",
  "./icons/search.svg": "6018",
  "./icons/section.svg": "74879",
  "./icons/sending.svg": "38410",
  "./icons/settings.svg": "46679",
  "./icons/share-role.svg": "67640",
  "./icons/share.svg": "96499",
  "./icons/shared-template.svg": "57338",
  "./icons/sidebar.svg": "19892",
  "./icons/signature.svg": "65726",
  "./icons/sort-down.svg": "46371",
  "./icons/sort-up.svg": "43166",
  "./icons/sort.svg": "22090",
  "./icons/spark.svg": "87673",
  "./icons/spreadsheet-spark.svg": "41898",
  "./icons/star-outline.svg": "91281",
  "./icons/star.svg": "29518",
  "./icons/status-ring.svg": "81411",
  "./icons/stop-sign.svg": "87142",
  "./icons/style-body.svg": "3426",
  "./icons/style-header.svg": "85755",
  "./icons/style-page.svg": "67577",
  "./icons/success.svg": "11863",
  "./icons/support.svg": "21471",
  "./icons/sync.svg": "85693",
  "./icons/table.svg": "59972",
  "./icons/task-grid.svg": "62824",
  "./icons/tasks.svg": "11042",
  "./icons/templates.svg": "74751",
  "./icons/textbox.svg": "43540",
  "./icons/theme.svg": "76133",
  "./icons/time.svg": "97259",
  "./icons/trash.svg": "78486",
  "./icons/ul.svg": "40547",
  "./icons/underline.svg": "27972",
  "./icons/unlock.svg": "36570",
  "./icons/unpin.svg": "63938",
  "./icons/upload.svg": "91655",
  "./icons/user-person.svg": "76075",
  "./icons/users.svg": "64264",
  "./icons/video.svg": "2871",
  "./icons/warning.svg": "39628",
  "./icons/watch.svg": "23251",
  "./icons/webhooks.svg": "97940",
  "./icons/word.svg": "52750",
  "./icons/workflow.svg": "43363",
  "./icons/x.svg": "70960",
  "./icons/yes-no.svg": "82887",
  "./icons/youtube.svg": "94937",
  "./images/api-dark.svg": "34205",
  "./images/api.svg": "59284",
  "./images/appearance-thumbnail.svg": "94373",
  "./images/builder-admissions-application.svg": "40897",
  "./images/builder-entries.svg": "32662",
  "./images/builder.svg": "83623",
  "./images/claude.svg": "80708",
  "./images/concentric/customer-story-logo-design-1.svg": "10954",
  "./images/concentric/customer-story-person-design-1.svg": "70932",
  "./images/concentric/customer-story-person-design-2.svg": "39597",
  "./images/create-responsive-forms.svg": "27015",
  "./images/excel.svg": "58587",
  "./images/form-skeleton.svg": "29222",
  "./images/gemini.svg": "92761",
  "./images/google-drive.svg": "62740",
  "./images/google-small.svg": "51503",
  "./images/hotdog.svg": "41325",
  "./images/hr/hr-email.svg": "11884",
  "./images/hr/hr-guest.svg": "28464",
  "./images/hr/hr-person-fields.svg": "64557",
  "./images/hr/hr-shared-view.svg": "28005",
  "./images/hr/salvation-army.svg": "48596",
  "./images/hr/setu.svg": "75632",
  "./images/integrations-api.svg": "29624",
  "./images/integrations-webhooks.svg": "66092",
  "./images/jotform.svg": "30635",
  "./images/lp-assets/capterra-logo.svg": "97543",
  "./images/lp-assets/circle-check.svg": "69068",
  "./images/lp-assets/circle-dismiss.svg": "44176",
  "./images/lp-assets/circle-minus.svg": "78088",
  "./images/lp-assets/cognito-forms-tally-sassworthy-graphic.svg": "38636",
  "./images/lp-assets/g2-logo.svg": "19534",
  "./images/lp-assets/hero.svg": "89689",
  "./images/lp-assets/product-hunt-logo.svg": "96008",
  "./images/lp-assets/software-advice-logo.svg": "92949",
  "./images/lp-assets/stars-abraham.svg": "76473",
  "./images/lp-assets/stars-air.svg": "90105",
  "./images/lp-assets/trust-radius-logo.svg": "21196",
  "./images/make-full-dark.svg": "55477",
  "./images/make-full.svg": "54364",
  "./images/make-horizontal.svg": "95305",
  "./images/make.svg": "66964",
  "./images/marketing/hero-marketing.svg": "11554",
  "./images/marketing/marketing-email.svg": "36694",
  "./images/marketing/marketing-guest.svg": "84738",
  "./images/marketing/marketing-shared.svg": "61821",
  "./images/mcp.svg": "28708",
  "./images/membership/member-email.svg": "19526",
  "./images/membership/member-guest.svg": "63954",
  "./images/membership/member-shared-view.svg": "13567",
  "./images/microsoft-onedrive.svg": "67677",
  "./images/microsoft-small.svg": "21726",
  "./images/money-badge-sm.svg": "14131",
  "./images/money-badge.svg": "44178",
  "./images/odata.svg": "23753",
  "./images/openai-light.svg": "65765",
  "./images/openai.svg": "35788",
  "./images/payment-americanexpress-sq.svg": "45766",
  "./images/payment-americanexpress.svg": "65777",
  "./images/payment-apple-sq.svg": "7180",
  "./images/payment-apple.svg": "60543",
  "./images/payment-card-sq.svg": "76206",
  "./images/payment-card.svg": "32249",
  "./images/payment-cash-sq.svg": "83657",
  "./images/payment-cash.svg": "37988",
  "./images/payment-discover-sq.svg": "95113",
  "./images/payment-discover.svg": "82148",
  "./images/payment-google-sq.svg": "83429",
  "./images/payment-google.svg": "71632",
  "./images/payment-mastercard-sq.svg": "43628",
  "./images/payment-mastercard.svg": "89919",
  "./images/payment-paypal-sq.svg": "86165",
  "./images/payment-paypal.svg": "20480",
  "./images/payment-providers.svg": "68205",
  "./images/payment-venmo-sq.svg": "15575",
  "./images/payment-venmo.svg": "45322",
  "./images/payment-visa-sq.svg": "6411",
  "./images/payment-visa.svg": "19262",
  "./images/paypal-2024-black.svg": "51300",
  "./images/paypal-small.svg": "60807",
  "./images/paypal-white-small.svg": "93735",
  "./images/paypal-white.svg": "33513",
  "./images/paypal.svg": "41865",
  "./images/people.svg": "84333",
  "./images/power-automate-full-dark.svg": "15289",
  "./images/power-automate-full.svg": "93784",
  "./images/power-bi.svg": "4915",
  "./images/powerautomate.svg": "24235",
  "./images/product-illustration.svg": "10990",
  "./images/religious/religious-email.svg": "82478",
  "./images/religious/religious-shared-view.svg": "5511",
  "./images/sandwich.svg": "12935",
  "./images/secure-payment.svg": "97148",
  "./images/square-small.svg": "65383",
  "./images/square-white-small.svg": "56807",
  "./images/square-white.svg": "77865",
  "./images/square.svg": "6953",
  "./images/sso-small.svg": "24545",
  "./images/stripe-small.svg": "61065",
  "./images/stripe-white.svg": "22691",
  "./images/stripe.svg": "93855",
  "./images/tableau.svg": "85782",
  "./images/venmo-small.svg": "24939",
  "./images/venmo.svg": "47661",
  "./images/wordpress.svg": "74019",
  "./images/zapier-full-dark.svg": "55190",
  "./images/zapier-full.svg": "58449",
  "./images/zapier-icon.svg": "47101",
  "./images/zapier.svg": "62423",
  "./logos/cogicon-circle-border.svg": "85940",
  "./logos/cogicon.svg": "80780",
  "./logos/cognito-pay-logo.svg": "37852",
  "./logos/hybrid-cognito-pay-logo.svg": "25083",
  "./logos/hybrid-logo.svg": "25856",
  "./logos/logo.svg": "32695",
  "./logos/reverse-cogicon.svg": "56459",
  "./logos/reverse-logo.svg": "90458",
  "./logos/stacked-hybrid-logo.svg": "36148",
  "./logos/stacked-logo.svg": "92899",
  "./logos/stacked-reverse-logo.svg": "70110",
  "./pricing-assets/individual-ui.svg": "54162",
  "./pricing-assets/pro-ui.svg": "62096",
  "./screenshot-component/hr-drag-drop.svg": "90905",
  "./screenshot-component/lookup-animation.svg": "78431",
  "./screenshot-component/marketing-drag-drop.svg": "61041",
  "./screenshot-component/member-devices.svg": "3542",
  "./screenshot-component/member-drag-drop.svg": "61329"
};


function __rspack_context_module(req) {
  var id = __rspack_context_module_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_module_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context_module.keys = () => (Object.keys(map));
__rspack_context_module.resolve = __rspack_context_module_resolve;
module.exports = __rspack_context_module;
__rspack_context_module.id = 36786;
